import { useLazyQuery } from '@vue/apollo-composable'
import { queryFundAccMarketList } from '@/graphql/holdings'
import { HoldingsMutationTypes } from '@/store/modules/holdings/mutations-type'
import { useStore } from 'vuex'
import storage, { StorageType } from '@/utils/storage'

export default function useFundAccMarket() {
  const store = useStore()
  const { load, onResult, loading, refetch } = useLazyQuery(queryFundAccMarketList)

  onResult((res) => {
    const { fundAccMarketList } = res.data
    if (fundAccMarketList?.ok) {
      store.commit(HoldingsMutationTypes.SET_FUND_ACC_MARKET_LIST, fundAccMarketList.data[0])
    }
  })

  const queryFundAccData = () => {
    const params = {
      filter: {
        exchangeType: store.state.holdings.marketTypeActive.value,
        fundAccount: storage.rcGetItem(StorageType.local, 'userInfo')
      }
    }
    // eslint-disable-next-line
    // @ts-ignore
    load(queryFundAccMarketList, params) || refetch(params)
  }

  return { queryFundAccData, loading }
}
